import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild} from '@angular/core';
import {EmitFilterControl, FilterConfigModel} from "../../model/filter-config.model";
import {AbstractControl, FormControl, FormGroup, Validators} from "@angular/forms";
import * as moment from 'moment';
import * as _ from 'lodash';

@Component({
  selector: 'dcu-body-filter',
  templateUrl: './body-filter.component.html',
  styleUrls: ['./body-filter.component.scss']
})
export class BodyFilterComponent implements OnChanges {

  @Input()
  filterData: FilterConfigModel[];
  @Input()
  triggerBtnName = 'Lọc';
  @Input()
  cancelBtnName = 'Hủy';
  @Input()
  disableTriggerBtn = false;
  @Input()
  errorMessage: string;
  @Input()
  isFormatted = false;
  @Input()
  portal: string;
  @Input()
  idFilter: string = 'filter';

  @Input() customLabelApply = 'Lọc';

  @Input() customLabelCancel = 'Hủy';

  @Input() isCustomCancelFilter = false;

  @Input() classCustom = "";
  @Output()
  onChangeSearch = new EventEmitter();
  @Output()
  onChangeForm = new EventEmitter();
  formGroup: FormGroup;

  @Output() clearValue = new EventEmitter();

  isLoadTemplate = true;
  isValidInput = true;
  constructor() {
    this.formGroup = new FormGroup({});
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.filterData && !_.isEqual(changes.filterData.currentValue, changes.filterData.previousValue)) {
      this.buildFromGroup();
    }
  }

  buildFromGroup() {
    if (this.filterData) {
      for (const filter of this.filterData) {
        this.formGroup.addControl(filter.controlName, new FormControl());
        if (!_.isNil(filter.defaultValue)) {
          this.formGroup.get(filter.controlName).patchValue(filter.defaultValue);
        }
        if (!_.isNil(filter.isDisable)) {
          this.formGroup.get(filter.controlName).disable();
        }
        if (!!filter.required && filter.required) {
          this.formGroup.get(filter.controlName).setValidators([Validators.required]);
        }
      }
      this.isLoadTemplate = false;
    }
  }

  onFilter() {
    if (this.formGroup.invalid) {
      this.isValidInput = false;
      return;
    }
    const searchValues = this.formGroup.getRawValue();
    for (const filter of this.filterData) {
      if (filter.type === 'date') {
        const dateValue = this.formGroup.get(filter.controlName).value;
        if (dateValue) {
          searchValues[filter.controlName] = moment(dateValue).format('YYYY-MM-DD');
        } else {
          searchValues[filter.controlName] = '';
        }
      }
      if (filter.type === 'dropdown' && filter.multiple) {
        const value = this.formGroup.get(filter.controlName).value;
        if (value && _.size(value) > 0) {
          searchValues[filter.controlName] = value.map(item => item.id);
        }
      }
    }
    this.onChangeSearch.emit(searchValues);
  }

  cancelFilter() {
    if (this.formGroup.invalid) {
      this.isValidInput = false;
      return;
    }

    const searchValues = this.formGroup.getRawValue();
    if (!this.isCustomCancelFilter) {
      if (this.filterData) {
        for (const filter of this.filterData) {
          if (filter.type === 'date') {
            searchValues[filter.controlName] = '';
          } else {
            searchValues[filter.controlName] = filter.defaultValue;
          }
          this.formGroup.get(filter.controlName).patchValue(filter.defaultValue);
        }
        this.isLoadTemplate = false;
      }
    }

    this.onChangeSearch.emit(searchValues);
  }

  onChangeData(event, fieldConfig: FilterConfigModel) {
    if(fieldConfig.onChangeValue) {
      fieldConfig.onChangeValue(event);
    }
    if (!_.isNil(fieldConfig.isSubscribeChange)) {
      const emitFilterControl: EmitFilterControl = {data: event, fieldConfig: fieldConfig, formGroup: this.formGroup};
      this.onChangeForm.emit(emitFilterControl);
    }
  }

  validateFromTo(e, fieldConfig: FilterConfigModel) {
    const controlName = fieldConfig.controlName;
    if(fieldConfig.rangeDateTo){
      this.compareFromToControls(fieldConfig.controlName, fieldConfig.rangeDateTo, e, controlName, fieldConfig);
    }
    if(fieldConfig.rangeNumberTo){
      const value = e.replace(/\,/g,'')
      this.compareFromToControlsForNumber(fieldConfig.controlName, fieldConfig.rangeNumberTo, +value, controlName);
    }
    if(fieldConfig.rangeNumberFrom){
      const value = e.replace(/\,/g,'')
      this.compareFromToControlsForNumber(fieldConfig.rangeNumberFrom, fieldConfig.controlName, +value, controlName);
    }
    this.onChangeData(e, fieldConfig);
  }

  compareFromToControls(fromControls: string, toControls: string, e, controlName, fieldConfig: FilterConfigModel) {
    if(controlName === toControls && e < this.formGroup.controls[fromControls].value) {
      this.formGroup.controls[fromControls].setValue(e);
    }else if(controlName === fromControls ) {
      if(e > this.formGroup.controls[toControls].value){
        this.formGroup.controls[toControls].setValue(e);
      }
      // set limit date of to Date field
      const index = this.filterData.findIndex(item => item.controlName === fieldConfig.rangeDateTo)
      this.filterData[index].minDate = e;
    }
  }

  compareFromToControlsForNumber(fromControls: string, toControls: string, e, controlName) {
    if(controlName === toControls
      && this.formGroup.controls[toControls].value
      && e < +this.formGroup.controls[fromControls].value.replace(/\,/g,'')) {
      this.formGroup.controls[fromControls].setValue(e);
    }else if(controlName === fromControls
      && this.formGroup.controls[toControls].value
      && e > +this.formGroup.controls[toControls].value.replace(/\,/g,'')) {
      this.formGroup.controls[toControls].setValue(e);
    }
  }

  onSelectRecord(dataSource, fieldConfig){
    this.formGroup.addControl(fieldConfig.lookUpControlNo, new FormControl());
    if(_.isNil(dataSource)){
      this.formGroup.get(fieldConfig.controlName).setValue(null);
      this.formGroup.get(fieldConfig.lookUpControlNo).setValue(null);
    }else{
      this.formGroup.get(fieldConfig.controlName).setValue(dataSource[fieldConfig.mappingFieldControlName]);
      this.formGroup.get(fieldConfig.lookUpControlNo).setValue(dataSource[fieldConfig.mappingFieldControlNo]);
    }
  }

  changeValue(value, required) {
    if (required) {
      this.isValidInput = value.length > 0 ? true : false;
    }
  }

  onClearValueDropdown($event) {
    this.clearValue.emit($event);
  }
}
